export const formatDateToHumanReadable = (date: Date): any => {
  const ISODate = new Date(date);
  const options = { year: "numeric", month: "2-digit", day: "2-digit" };

  const formattedDate = ISODate.toLocaleDateString("de-DE", options);

  return formattedDate;
};

export const test = "test";
